import { render } from "./ResponseRegisterModal.vue?vue&type=template&id=4ed70e66&scoped=true"
import script from "./ResponseRegisterModal.vue?vue&type=script&lang=js"
export * from "./ResponseRegisterModal.vue?vue&type=script&lang=js"

import "./ResponseRegisterModal.vue?vue&type=style&index=0&id=4ed70e66&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed70e66"]])

export default __exports__